export default process.env.REACT_APP_S3_BUCKET_ERP;
